interface Props {
  className?: string;
}

export function LogoIcon(props: Props) {
  return (
    <svg className={props.className} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <g transform="translate(-179 -125)">
        <rect width="32" height="32" transform="translate(179 125)" fill="rgba(255,255,255,0)"/>
        <rect width="14" height="14" transform="translate(179 125)" fill="#f12626"/>
        <rect width="14" height="14" transform="translate(179 143)" fill="#f12626"/>
        <rect width="14" height="14" transform="translate(197 125)" fill="#f12626"/>
        <rect width="14" height="14" transform="translate(197 143)" fill="#f12626"/>
      </g>
    </svg>
  );
}
